// Firebase Collection Names
export const COLLECTIONS = {
    USERS: 'users',
    CATEGORIES: 'categories',
    PRODUCTS: 'products', // Changed from BOOKS
    STATIONERY: 'products', // Same collection
    ORDERS: 'orders',
    COUPONS: 'coupons',
    COUPON_USAGE: 'couponUsage',
    TESTIMONIALS: 'testimonials',
    CONFIGURATIONS: 'configurations',
    ANALYTICS: 'analytics',
    OTPS: 'otps',
    NOTIFICATIONS: 'notifications',
    NOTIFICATION_TEMPLATES: 'notificationTemplates',
    SECTIONS: 'sections',
    REVIEWS: 'reviews',
};
// Storage Paths
export const STORAGE_PATHS = {
    PRODUCTS: 'products', // Changed
    STATIONERY: 'products/stationery', // Subfolder
    CATEGORIES: 'categories',
    USERS: 'users',
    TESTIMONIALS: 'testimonials',
};
// Order Status Labels
export const ORDER_STATUS_LABELS = {
    placed: 'Order Placed',
    confirmed: 'Confirmed',
    packed: 'Packed',
    shipped: 'Shipped',
    delivered: 'Delivered',
    cancelled: 'Cancelled',
};
// Payment Status Labels
export const PAYMENT_STATUS_LABELS = {
    pending: 'Pending',
    // completed: 'Completed',
    paid: 'Paid',
    failed: 'Failed',
    refunded: 'Refunded',
};
// Pagination
export const DEFAULT_PAGE_SIZE = 20;
export const MAX_PAGE_SIZE = 100;
// Validation
export const VALIDATION = {
    PHONE_MIN_LENGTH: 10,
    PHONE_MAX_LENGTH: 15,
    PASSWORD_MIN_LENGTH: 8,
    OTP_LENGTH: 6,
    OTP_EXPIRY_MINUTES: 5,
    MAX_CART_QUANTITY: 10,
    MIN_ORDER_VALUE: 100,
    MAX_UPLOAD_SIZE_MB: 5,
};
// Indian States
export const INDIAN_STATES = [
    'Andhra Pradesh',
    'Arunachal Pradesh',
    'Assam',
    'Bihar',
    'Chhattisgarh',
    'Goa',
    'Gujarat',
    'Haryana',
    'Himachal Pradesh',
    'Jharkhand',
    'Karnataka',
    'Kerala',
    'Madhya Pradesh',
    'Maharashtra',
    'Manipur',
    'Meghalaya',
    'Mizoram',
    'Nagaland',
    'Odisha',
    'Punjab',
    'Rajasthan',
    'Sikkim',
    'Tamil Nadu',
    'Telangana',
    'Tripura',
    'Uttar Pradesh',
    'Uttarakhand',
    'West Bengal',
    'Andaman and Nicobar Islands',
    'Chandigarh',
    'Dadra and Nagar Haveli and Daman and Diu',
    'Delhi',
    'Jammu and Kashmir',
    'Ladakh',
    'Lakshadweep',
    'Puducherry',
];
// Languages
export const LANGUAGES = [
    'English',
    'Hindi',
    'Bengali',
    'Tamil',
    'Telugu',
    'Marathi',
    'Gujarati',
    'Kannada',
    'Malayalam',
    'Punjabi',
    'Urdu',
];
// Error Messages
export const ERROR_MESSAGES = {
    NETWORK_ERROR: 'Network error. Please check your connection.',
    UNAUTHORIZED: 'You are not authorized to perform this action.',
    NOT_FOUND: 'Resource not found.',
    VALIDATION_ERROR: 'Please check your input and try again.',
    GENERIC_ERROR: 'Something went wrong. Please try again.',
    SESSION_EXPIRED: 'Your session has expired. Please login again.',
};
// Success Messages
export const SUCCESS_MESSAGES = {
    BOOK_ADDED: 'Book added successfully',
    BOOK_UPDATED: 'Book updated successfully',
    BOOK_DELETED: 'Book deleted successfully',
    ORDER_PLACED: 'Order placed successfully',
    PROFILE_UPDATED: 'Profile updated successfully',
    ADDRESS_ADDED: 'Address added successfully',
    PAYMENT_SUCCESS: 'Payment completed successfully',
};
